import { Icon } from "@iconify/react"
import { Button, Card, Flex, Grid, Input, message, Pagination, Table, Tag } from "antd"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { faqService } from "../../../services/faq.service";
import useTitleStore from "../../../store/titleStore";
import { useTableHeight } from "../../../hooks/useTableHeight";
import useDebounce from "../../../hooks/useDebounce";
import TableAction from "../../../components/TableAction";
import UpdatedByCell from "../../../components/UpdatedByCell";

export default function FaqIndex(){

  const breakpoint = Grid.useBreakpoint()

  const navigate = useNavigate();
  const { setTitle } = useTitleStore();
  const queryClient = useQueryClient();
  const tableHeight = useTableHeight();
  
  const [messageApi, contextHolder] = message.useMessage();
  const [keyword, setKeyword] = useState("");
  const debouncedKeyword = useDebounce(keyword, 500);
  const [dataParams, setDataParams] = useState({
    limit: 10,
    page: 1,
    filter: []
  })

  const { data: informationData , isLoading, isRefetching } = useQuery({
    queryKey: ['faqs', dataParams],
    queryFn: () => faqService.fetchAll(dataParams),
    placeholderData: keepPreviousData,
  })

  const { mutate: handleDelete, isPending: deleteLoading } = useMutation({
    mutationFn: (id) => faqService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries('faqs');
      messageApi.success('Data berhasil dihapus');
    },
    onError: (error) => {
      console.log(error)
    }
  })

  useEffect(() => {
    setTitle("FAQ");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataParams((prev) => ({
      ...prev,
      filter: [
        {
          field: 'question',
          operator: 'like',
          value: debouncedKeyword
        }
      ]
    }));
  }, [debouncedKeyword]);

  const handleChangePage = (page, pageSize) => {
    setDataParams({
      ...dataParams,
      limit: pageSize,
      page
    })
  }

  const columns = [
    {
      title: 'No',
      align: 'center',
      width: 80,
      render: (text, record, index) =>  index + 1,
      fixed: breakpoint.md && 'left'
    },
    {
      title: 'Pertanyaan',
      dataIndex: 'question',
      width: 210,
      fixed: breakpoint.md && 'left'
    },
    {
      title: 'Kategori',
      dataIndex: 'category',
      width: 210,
      render: val => val?.name
    },
    {
      title: 'Pin Ke Beranda',
      dataIndex: 'isPinned',
      width: 210,
      render: val => val ? <Tag color="cyan" >Ya</Tag> : <Tag >Tidak</Tag>
    },
    {
      title: 'Tanggal Update',
      width: 210,
      render: val => <UpdatedByCell value={val} />,
    },
    {
      className: 'last-cell-p',
      title: 'Aksi',
      align: 'right',
      width: 120,
      fixed: 'right',
      render: record => (
        <TableAction
          onClickEdit={() => navigate('/customer-care/faq/detail/'+record.id)}
          handleDelete={() => handleDelete(record.id)}
          deleteLoading={deleteLoading}
        />
      )
    },
  ]



  return (
    <Card
      styles={{
        body: {
          paddingLeft: 0,
          paddingRight: 0
        }
      }}
    >
      {contextHolder}
      <Flex justify="space-between" gap={20} style={{ paddingInline: 24, marginBottom: 24 }} >
        <Input 
          style={{ width: 320 }} 
          prefix={<Icon icon="hugeicons:search-01" width="16" height="16" />}
          placeholder="cari..."
          onChange={e => setKeyword(e.target.value)}
          value={keyword}
        />
        <Button 
          variant="solid" 
          color="primary"  
          icon={<Icon icon="duo-icons:add-circle" width="22" height="22" />}
          onClick={() => navigate('/customer-care/faq/create')}
          style={{ minWidth: 38 }}
        >
          {breakpoint.md && 'Tambah FAQ'}
        </Button>
      </Flex>
      <Table
        columns={columns}
        pagination={false}
        size="small"
        loading={isLoading || isRefetching}
        rowKey={'id'}
        scroll={{ y: tableHeight }}
        dataSource={informationData?.data}
      />
       <Pagination
          style={{ marginInline: 24, marginTop: 16 }}
          total={informationData?.pagination?.total}
          showSizeChanger={{
            showSearch: false,
          }}
          pageSizeOptions={['10', '20', '50']}
          current={informationData?.pagination?.page}
          pageSize={dataParams.limit}
          align="end"
          onChange={handleChangePage}
        />
    </Card>
  )
}